import React, { Component } from "react";
import { HashRouter as Router, Route, Switch, Link } from "react-router-dom";
import Loading from "./Loading";
import Portfolio from "./Portfolio";
import ImagePreloader from "../ImagePreloader";
import Project from "./Project";
import store from "../Store";

// DATA
import manifest from "../data/img_manifest.json";
// import manifest from "../data/update_03.02.2018.json";
// import manifest from "../data/img_manifest_1.json";
// import manifest from "../data/img_manifest_3.json";

// CSS
import "./App.css";

store.seed(manifest);
// console.log(`manifest.length`, manifest.length);

export default class App extends Component {
	state = {
		loaderComplete: false,
		loadedPerc: 0,
	};

	componentDidMount = () => {
		this.preloadImages();
	};

	preloadImages = () => {
		let images = [];

		store.data.forEach(object => {
			images = images.concat(object.src);
		});

		this.imagePreloader = new ImagePreloader(
			images,
			this.closeLoader,
			this.updateLoader
		);
	};

	// Loader Methods

	closeLoader = () => {
		this.setState({ loadedPerc: 1 });
	};

	updateLoader = perc => {
		// console.log(`perc`, perc);
		this.setState({ loadedPerc: perc });
	};

	removeLoader = () => {
		this.setState({ loaderComplete: true });
	};

	render() {
		const { loaderComplete, loadedPerc } = this.state;

		return (
			<Router>
				<div className="App">
					<header className="Header">
						<Link to="/">
							<h1>David Lochhead &mdash; Creative Coder</h1>
						</Link>
						<div className="Contact">
							Get in touch&nbsp;→&nbsp;<a href="mailto:hello@davidlochhead.xyz">
								hello@davidlochhead.xyz
							</a>
						</div>
					</header>

					<Switch>
						<Route
							exact
							path="/"
							render={() => <Portfolio loaderComplete={loaderComplete} />}
						/>
						<Route
							exact
							path="/test"
							render={() => loaderComplete && <Test />}
						/>
						<Route
							exact
							path="/:id"
							render={match =>
								loaderComplete && <Project id={match.match.params.id} />
							}
						/>
						<Route render={() => loaderComplete && <Nothing />} />
					</Switch>

					{loaderComplete === false && (
						<Loading perc={loadedPerc} onComplete={this.removeLoader} />
					)}
				</div>
			</Router>
		);
	}
}

const Test = () => (
	<div className="test">
		<Link to="/">BACK</Link>
	</div>
);

const Nothing = () => (
	<div className="test">
		<p>Nothing here! Sorry.</p>
		<br />
		<Link to="/">Home</Link>
	</div>
);



// WEBPACK FOOTER //
// ./src/components/App.js